// utils/cachedata.js
export const setCache = (key, data, ttl = 24 * 60 * 60 * 1000) => {
    const cacheEntry = {
        timestamp: Date.now(),
        data,
        ttl,
    };
    localStorage.setItem(key, JSON.stringify(cacheEntry));
};

export const getCache = (key) => {
    const item = localStorage.getItem(key);
    if (!item) return null;

    const { timestamp, data, ttl } = JSON.parse(item);
    if (Date.now() - timestamp > ttl) {
        localStorage.removeItem(key); // Cache expired
        return null;
    }
    return data;
};
